import { ContinueTradingButton } from './continue-trading-button';

export default ContinueTradingButton;
